import { SessionContext, SessionContextFormData, MeetingType } from '../types/sessionContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export class SessionContextService {
  
  /**
   * Get session context for a session
   */
  static async getSessionContext(sessionId: string): Promise<SessionContext> {
    const response = await fetch(`${API_BASE_URL}/session-context/${sessionId}`);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to load session context');
    }

    const responseData = await response.json();
    return responseData.data;
  }

  /**
   * Save session context
   */
  static async saveSessionContext(sessionId: string, contextData: SessionContextFormData): Promise<SessionContext> {
    const response = await fetch(`${API_BASE_URL}/session-context/${sessionId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(contextData),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to save session context');
    }

    const responseData = await response.json();
    return responseData.data;
  }

  /**
   * Delete session context
   */
  static async deleteSessionContext(sessionId: string): Promise<void> {
    const response = await fetch(`${API_BASE_URL}/session-context/${sessionId}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to delete session context');
    }
  }

  /**
   * Get default meeting types
   */
  static async getDefaultMeetingTypes(): Promise<MeetingType[]> {
    const response = await fetch(`${API_BASE_URL}/session-context/defaults/meeting-types`);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to load default meeting types');
    }

    const responseData = await response.json();
    return responseData.data;
  }
}